import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class TokenConfigService {

    static generateTokenConfig = id => {
        return axios.post(`${PATH.GENERATE_RESTAURANT_TOKEN}/${id}`, null);
    }

    static getRestaurantToken = id => {
        return axios.get(`${PATH.GET_RESTAURANT_TOKEN}/${id}`);
    }
}
